// From the client's "List of M C, BoT, Examination Board and Sub Committee" dated
// 2 Oct 26. Only the two lists the client chose to publish are here; the Exam
// Board and the sub-committees stay in the PDF.
export interface Person {
  name: string;
  role: string;
}

// Board of Trustees 2023-2029
export const TRUSTEES: Person[] = [
  { name: 'Manish D. Warekar', role: 'Chairman' },
  { name: 'Mustafa Z. Patanwala', role: 'Secretary' }, // the site used to say "Mustufa": VERIFY
  { name: 'Sanjay S. Sule', role: 'Member' },
  { name: 'Pandurang R. Naik', role: 'Member' },
  { name: 'Laxmikant A. Desai', role: 'Member' },
];

// Managing Committee 2025-2027
export const MANAGING_COMMITTEE: Person[] = [
  { name: 'Shailesh C. Vyas', role: 'President' },
  { name: 'Vinay R. Mahajan', role: 'Vice President' },
  { name: 'Sameer D. Warekar', role: 'Chairman, Exam Board' },
  // The sub-committee lists call Paresh N. Gohel "Gen. Secretary, Ex. Officio": VERIFY.
  { name: 'Nitin U. Zambre', role: 'General Secretary' },
  { name: 'Ramesh S. Vairalkar', role: 'Joint Secretary' },
  { name: 'Devidas M. Kalaskar', role: 'Treasurer' },
  { name: 'Bhalchandra A. Patil', role: 'Joint Treasurer' },
  { name: 'Paresh N. Gohel', role: 'Member' },
  { name: 'Suhas Rao', role: 'Member' },
  { name: 'Suhas M. Shaligram', role: 'Member' },
  { name: 'Vidhydhar S. Kaduskar', role: 'Member' }, // spelt "Vidhyadhar" elsewhere in the document: VERIFY
  { name: 'Dhanji J. Sawant', role: 'Member' },
  { name: 'Girish Bajaj', role: 'Member' },
];
